import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Carousel } from 'antd';
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft, FaArrowRight, FaRegComments } from "react-icons/fa";
import { MdDiscount } from "react-icons/md";
import { HiOutlineUserCircle } from "react-icons/hi";
import image1 from "../../../assets/frontendassets/websiteimages/Transform Your Business with These 2024 Trends (1).jpg";
import image2 from "../../../assets/frontendassets/websiteimages/HowtoSuperchargeYourBusinessGrowthwithNet4Surge(1).jpg";
import image3 from "../../../assets/frontendassets/websiteimages/The Ultimate Guide to Effective Digital Marketing in 2024 (1).jpg";
import blog1 from "../../../assets/backendassets/blog1.png";
import staticBlog1 from "../../../assets/frontendassets/BlogsImages/1.png";
import staticBlog2 from "../../../assets/frontendassets/BlogsImages/2.png";
import staticBlog3 from "../../../assets/frontendassets/BlogsImages/3.png";
import staticBlog4 from "../../../assets/frontendassets/BlogsImages/1.png";
import { getBlogs } from "../../../utils/API";
import BlogDetail from './BlogDetail';

const Blog = () => {
  const [slidesToShow, setSlidesToShow] = useState(2);
  const [blogItems, setBlogItems] = useState<any[]>([]);
  const [blogsData, setBlogsData] = useState<any[]>([]);  // Corrected setBlogsData
  const { slug } = useParams<{ slug: string }>();
  const [blogDetail, setBlogDetail] = useState<any | null>(null);
  const [blogssData, setBlogssData] = useState<any>([]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setSlidesToShow(3);
      } else if (window.innerWidth >= 768) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(1);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const BlogsData = async () => {
      try {
        const response = await getBlogs();
        if (response.blogs && response.blogs.length > 0) {  // Ensure correct property
          setBlogsData(response.blogs);
        }
      } catch (error) {
        console.error("Error fetching blog data:", error);
      }
    };

    BlogsData();
  }, []);

  const navigate = useNavigate();
  const redirectToBlog = (slug: string) => {
    navigate(`/blog/${slug}`);
  };


  return (
    <>
      {/* <Row className="sm:pt-8 sm:px-8 sm:pb-8 md:pt-8 md:px-8 md:pb-4 xl:pt-16 xl:px-48 xl:pb-8">
        </Row> */}
     <div className="pt-10 bg-[#FFF8EC]  xl:px-12 xl:40vh 2xl:h-40vh xxs:p-3 xs:p-3 md:px-6 lg:px-10">
     
             <Row className="pt-10 bg-[#FFF8EC] lg:px-0  lg:ps-0     md:flex-col">
          <div className="flex items-center pb-3 pl-2">
            <hr className="w-36 " />
            <div className=" text-black pl-4 xl:text-[20px] " style={{ letterSpacing: "1.5px", fontFamily: '"Manrope", sans-serif' }}>
              FROM THE BLOG
            </div>
          </div>
          <h1 className='text-b lack text-xl sm:text-[30px] xs:mb-5 xxs:mb-5 md:mb-10 pl-2'>Latest news & articles from the blog</h1>
          <Col span={24}>
            <Carousel autoplay autoplaySpeed={3000} dots={false} slidesToShow={slidesToShow} draggable>
            {blogsData.length > 0 ? (
  blogsData.map((blogPost, index) => (
    <div key={index} className="rounded-lg p-2">
      <Link className='block no-underline hover:no-underline text-black' to={`/blog/${blogPost.slug}`}>
        <div className="">
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}/blog/${blogPost.image}`}
            alt="SliderImage"
            className="object-cover w-full h-64 rounded-lg"
          />
          <div className="pt-4 p-2 md:h-[11.5rem] h-auto">
            <h3 className="text-[22px]  mb-3">{blogPost.title.slice(0, 50)}...</h3>
                  <p
  className="text-[16px] text-black mb-4"
  dangerouslySetInnerHTML={{
    __html: `
      ${blogPost.content[0]?.description.slice(0, 80)}... 
      <a 
        href="/blog/${blogPost.slug}" 
        class="text-black font-semibold"
        onclick="event.preventDefault(); window.location.href='/blog/${blogPost.slug}'"
      >
        Read More!
      </a>
    `,
  }}
></p>
          </div>
        </div>
      </Link>
    </div>
  ))
) : (
  <div className="text-center text-gray-500 mt-10">
    <p>No blog posts found. Please check back later!</p>
  </div>
)}

            </Carousel>
          </Col>
        </Row>
      </div>

    </>

  );
};

export default Blog;
